import React from 'react';

export default class Card extends React.Component {
  render() {
    const classes = ['card'];
    if (this.props.className) {
      classes.push(this.props.className);
    }
    return <div className={classes.join(' ')}>{this.props.children}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/card.js